/**
 * AI 分析 - 思考过程折叠面板
 */
import React from 'react';
import { Collapse, Space, Typography, Tag, Divider } from 'antd';
import { BulbOutlined } from '@ant-design/icons';

const { Text, Paragraph } = Typography;

interface ThinkingProcess {
  data_observation: string;
  user_context_analysis: string;
  reasoning_logic: string;
  confidence_level: 'high' | 'medium' | 'low';
}

interface AIThinkingProcessProps {
  thinkingProcess?: ThinkingProcess;
}

export const AIThinkingProcess: React.FC<AIThinkingProcessProps> = ({ thinkingProcess }) => {
  if (!thinkingProcess) return null;

  const getConfidenceLevelText = (level: string) => {
    const map: Record<string, string> = {
      'high': '高',
      'medium': '中',
      'low': '低',
    };
    return map[level] || level;
  };

  const getConfidenceColor = (level: string) => {
    const map: Record<string, string> = {
      'high': 'green',
      'medium': 'orange',
      'low': 'red',
    };
    return map[level] || 'default';
  };

  return (
    <Collapse
      style={{ marginBottom: 16 }}
      items={[
        {
          key: 'thinking',
          label: (
            <Space>
              <BulbOutlined style={{ color: '#fa8c16' }} />
              <Text strong>智能分析思路（点击展开）</Text>
              <Tag color={getConfidenceColor(thinkingProcess.confidence_level)}>
                信心度: {getConfidenceLevelText(thinkingProcess.confidence_level)}
              </Tag>
            </Space>
          ),
          children: (
            <Space direction="vertical" style={{ width: '100%' }} size="middle">
              <div>
                <Text type="secondary" strong>📊 数据观察</Text>
                <Paragraph style={{ marginTop: 8, marginBottom: 0 }}>
                  {thinkingProcess.data_observation}
                </Paragraph>
              </div>
              <Divider style={{ margin: '8px 0' }} />
              <div>
                <Text type="secondary" strong>🎯 用户情境分析</Text>
                <Paragraph style={{ marginTop: 8, marginBottom: 0 }}>
                  {thinkingProcess.user_context_analysis}
                </Paragraph>
              </div>
              <Divider style={{ margin: '8px 0' }} />
              <div>
                <Text type="secondary" strong>🧠 推理逻辑</Text>
                <Paragraph style={{ marginTop: 8, marginBottom: 0 }}>
                  {thinkingProcess.reasoning_logic}
                </Paragraph>
              </div>
            </Space>
          ),
        },
      ]}
    />
  );
};

